var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Map Test")]),_c('div',{attrs:{"id":"mapid"}}),_c('v-btn',{on:{"click":_vm.changeColor}},[_vm._v("Change Color")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }